import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialColorOutput, materialFloatOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"

export interface ShaderToRgbSockets extends MaterialNodeSockets {
    inputs: {
        shader: "closure"
    }
    settings: {
        alpha: "float" // found in inputs: -; found in settings: float; inferred from data: float
        color: "color" // found in inputs: -; found in settings: color; inferred from data: float3
    }
    outputs: {
        color: "color"
        alpha: "float"
    }
}

export const shaderToRgbDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeShaderToRGB,
    },
    nodeClass: "ShaderToRgb",
    ui: {
        label: "Shader to RGB",
        color: "#4987af",
        items: [
            {name: "color", valueType: "color", label: "Color", output: true},
            {name: "alpha", valueType: "float", label: "Alpha", output: true},
            {name: "shader", valueType: "closure", label: "Shader", input: true, setting: false},
        ],
        support: {
            cycles: false,
            three: false,
        },
    },
    validation: {
        returns: z.strictObject({color: materialColorOutput, alpha: materialFloatOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({
                shader: optionalMaterialInput,
            }),
            settings: z.strictObject({
                alpha: z.optional(z.number()),
                color: z.optional(color),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<ShaderToRgbSockets>
